import { Button, Col, Dropdown, Input, Menu, Row, Select, Table, Typography, message } from 'antd';
import axios from 'axios';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import "react-calendar/dist/Calendar.css";
import { DateRangePicker } from "react-date-range";
import { postingService } from '../../../shared';
import { fontColor, MAIN_BACKGROUND_COLOR } from '../../../styleConstants';

const { Option } = Select;
const { Title } = Typography;

const CityStatsTable = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const [selectedCity, setSelectedCity] = useState('All');

  const [datesBetween, setDateBetween] = useState({
    startDate: dayjs(new Date()).subtract(1,"month").toDate(),
    endDate: new Date(),
  });

    const [dropdrownshow, setdropdrownshow] = useState(false);
  

  const fetchData = async (startDate, endDate) => {
    try {
      setLoading(true);
      const response = await axios.get(postingService+'/api/v1/posts/stats', {
        params: { startDate, endDate },
      });
      setData(response.data.data);
    } catch (error) {
      message.error('Failed to fetch data.');
    } finally {
      setLoading(false);
    }
  };


  const [dateSelection, setdateSelection] = useState({
    startDate: dayjs(new Date()).subtract(1,"month").toDate(),
    endDate: new Date(),
    key: "selection",
  });


  useEffect(() => {
    fetchData(dayjs(datesBetween.startDate).format('YYYY-MM-DD'), dayjs(datesBetween.endDate).format('YYYY-MM-DD'));
  }, [datesBetween]);




  const handleCityChange = (value) => {
    setSelectedCity(value);
  };

  const filteredCities = data?.citiesWithTypes?.filter((item) => {
    return selectedCity === 'All' || item.city === selectedCity;
  });

 
  const handleSelect = (ranges) => {
    if (ranges.hasOwnProperty("range1")) {
      setdateSelection(ranges.range1);
    } else {
      setdateSelection(ranges.selection);
    }
  };
  const PickDate = () => {
    setdropdrownshow(false);
    setDateBetween({
      startDate: dateSelection.startDate,
      endDate: dateSelection.endDate,
    });
  };

  
  const columns = [
    { title: 'City', dataIndex: 'city', key: 'city' ,
      
    },
    { title: 'Total Posts', dataIndex: 'cityTotal', key: 'cityTotal' },
    { title: 'Call Count', dataIndex: 'cityCallCount', key: 'cityCallCount' },
    { title: 'Visits', dataIndex: 'cityVisits', key: 'cityVisits' },
  ];

  const expandedRowRender = (record) => {
    const innerColumns = [
      {
        title: 'Type',
        dataIndex: 'type',
        key: 'type',
        onHeaderCell: () => ({
          style: { backgroundColor: MAIN_BACKGROUND_COLOR, color:fontColor, fontWeight: 'bold' },
        }),
      },
      {
        title: 'Total Posts',
        dataIndex: 'totalPosts',
        key: 'totalPosts',
        onHeaderCell: () => ({
          style: { backgroundColor: MAIN_BACKGROUND_COLOR, color:fontColor, fontWeight: 'bold' },
        }),
      },
      {
        title: 'Active',
        dataIndex: 'activePosts',
        key: 'activePosts',
        onHeaderCell: () => ({
          style: { backgroundColor: MAIN_BACKGROUND_COLOR, color:fontColor, fontWeight: 'bold' },
        }),
      },
      {
        title: 'Featured',
        dataIndex: 'featuredPosts',
        key: 'featuredPosts',
        onHeaderCell: () => ({
          style: { backgroundColor: MAIN_BACKGROUND_COLOR, color:fontColor, fontWeight: 'bold' },
        }),
      },
      {
        title: 'Total Call',
        dataIndex: 'callCount',
        key: 'callCount',
        onHeaderCell: () => ({
          style: { backgroundColor: MAIN_BACKGROUND_COLOR, color:fontColor, fontWeight: 'bold' },
        }),
      },
      {
        title: 'Visits',
        dataIndex: 'totalVisits',
        key: 'totalVisits',
        onHeaderCell: () => ({
          style: { backgroundColor: MAIN_BACKGROUND_COLOR, color:fontColor, fontWeight: 'bold' },
        }),
      },
      {
        title: 'Avg Visits',
        dataIndex: 'avgVisits',
        key: 'avgVisits',
        onHeaderCell: () => ({
          style: { backgroundColor: MAIN_BACKGROUND_COLOR, color:fontColor, fontWeight: 'bold' },
        }),
      },
    ];
    return <Table className='inner-header'  columns={innerColumns} dataSource={record.types} pagination={false} rowKey="type" scroll={{ x: "max-content" }} />;
  };

  const menu = (
    <Menu>
      <Menu.Item>
        <DateRangePicker
          rangeColors={[MAIN_BACKGROUND_COLOR]}
          ranges={[dateSelection]}
          onChange={handleSelect}
        />
      </Menu.Item>
      <Menu.Item >
        <Row>
          <Col span={10} >
            <Button
              onClick={() => PickDate()}
              style={{ width: "100%" }}
              type={"primary"}
            >
              Select
            </Button>
          </Col>
          <Col push={2}  span={10}>
            <Button
              onClick={() => {
                setdropdrownshow(false);
                setdateSelection({ ...dateSelection, ...datesBetween });
              }}
              style={{ width: "100%" }}
            >
              Cancel
            </Button>
          </Col>
        </Row>
      </Menu.Item>
    </Menu>
  );

  return (
    <div style={{ padding: 24 }}>
      <Title level={4}>Post Statistics by City & Type</Title>
      <Row gutter={[16, 16]} style={{ marginBottom: 16 }}>
        <Col xs={24} sm={24} md={12} lg={8}>
          <Dropdown
            onVisibleChange={setdropdrownshow}
            visible={dropdrownshow}
            overlay={menu}
          >
            <Row justify="space-between">
              <Col span={11}>
                <Input
                  type="primary"
                  value={new Date(dateSelection.startDate).toDateString()}
                  placeholder="start Date"
                />
              </Col>
              <Col span={11}>
                <Input
                  type="primary"
                  value={new Date(dateSelection.endDate).toDateString()}
                  placeholder="End Date"
                />
              </Col>
            </Row>
          </Dropdown>
        </Col>
        <Col xs={24} sm={24} md={12} lg={8}>
          <Select
            style={{ width: "100%" }}
            value={selectedCity}
            onChange={handleCityChange}
          >
            <Option value="All">All</Option>
            {data?.overall?.uniqueCities?.map((city) => (
              <Option key={city} value={city}>
                {city}
              </Option>
            ))}
          </Select>
        </Col>
      </Row>
      <Table
        columns={columns}
        dataSource={filteredCities}
        rowKey="city"
        loading={loading}
        expandable={{ expandedRowRender }}
        bordered
        scroll={{ x: 'max-content' }}
      />
    </div>
  );
};

export default CityStatsTable;